// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nnjQbyvo6p85dRdQ {
  border-radius: 16px;
  max-width: 480px;
  width: 100%;
}

.nnjQbyvo6p85dRdQ .p-dialog-header {
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  background-color: #f3f5f7;
}

.nnjQbyvo6p85dRdQ .p-dialog-content {
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  background-color: #f3f5f7;
}

.nnjQbyvo6p85dRdQ .p-dialog-content p {
  margin-bottom: 32px;
}

.nnjQbyvo6p85dRdQ button {
  width: 50%;
  height: 56px;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.nnjQbyvo6p85dRdQ .p-dialog-header-close {
  width: 34px;
  height: 34px;
}

.nWk881ue746gkOLT {
  margin-bottom: 24px;
}

.HGMUqI2pj2Iu0HUZ {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
}

.cq3mkuAwGgL04VoX {
  width: 100%;
  padding-inline: 22px;
  border-radius: 16px;
  height: 56px;
  font-size: 20px;
  margin-bottom: 32px;
  border: none;
  outline: none;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}

.cq3mkuAwGgL04VoX::placeholder {
  color: #a4a4a4;
  font-weight: 400;
}

.L9d7mBqzrsaaNfCx {
  flex: 1;
  background-color: #20336c;
  border-color: #20336c;
}

.nePuVgj7MA0xxekg {
  flex: 1;
  background-color: transparent;
  border-color: #20336c;
  color: #20336c;
}

.Pmlp5gzM2Q0MGbyt {
  font-size: 14px;
  color: #666;
  margin-top: 12px;
}

.Tn7rqJi1qRAE5Exv {
  font-size: 14px;
  color: #1976d2;
  margin-top: 12px;
  text-decoration: underline;
  cursor: pointer;
  background: none;
  border: none;
}

.jQU8hZCKbTQKV2Re {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 16px;
}

.jQU8hZCKbTQKV2Re:last-of-type {
  margin-bottom: 32px;
}

.R01KiJXJW34Vj1xT {
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #303030;
  margin-bottom: 6px;
}

.jQU8hZCKbTQKV2Re .cq3mkuAwGgL04VoX {
  margin-bottom: 0;
}

.wvyYrTfKRsg5nVGe {
  margin-top: 16px;
  font-size: 13px;
  color: #666;
  text-align: center;
  width: 100%;
}

.XsvlCH_jhU0rN6jN {
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
}

.vL03okZs5ACBWsq5 {
  position: relative;
  width: 100%;
}

.vL03okZs5ACBWsq5 .cq3mkuAwGgL04VoX {
  padding-right: 48px;
}

.LcgwsQq__wGMqLpY {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: fit-content !important;
  display: inline-flex;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: #a4a4a4;
  font-size: 18px;
  line-height: 1;
  align-items: center;
}

.LcgwsQq__wGMqLpY:hover {
  color: #303030;
}
`, "",{"version":3,"sources":["webpack://./src/components/Auth/Auth.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;AACR;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,cAAc;EACd,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".otpModal {\r\n  border-radius: 16px;\r\n  max-width: 480px;\r\n  width: 100%;\r\n}\r\n\r\n.otpModal :global(.p-dialog-header) {\r\n  border-top-left-radius: 16px;\r\n  border-top-right-radius: 16px;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.otpModal :global(.p-dialog-content) {\r\n  border-bottom-left-radius: 16px;\r\n  border-bottom-right-radius: 16px;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.otpModal :global(.p-dialog-content p) {\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.otpModal button {\r\n  width: 50%;\r\n  height: 56px;\r\n  border-radius: 16px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.otpModal :global(.p-dialog-header-close) {\r\n  width: 34px;\r\n  height: 34px;\r\n}\r\n\r\n.otpModalText {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.uploadContent {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 0;\r\n}\r\n\r\n.input {\r\n  width: 100%;\r\n  padding-inline: 22px;\r\n  border-radius: 16px;\r\n  height: 56px;\r\n  font-size: 20px;\r\n  margin-bottom: 32px;\r\n  border: none;\r\n  outline: none;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n  box-sizing: border-box;\r\n}\r\n\r\n.input::placeholder {\r\n  color: #a4a4a4;\r\n  font-weight: 400;\r\n}\r\n\r\n.otpModalBtnVerify {\r\n  flex: 1;\r\n  background-color: #20336c;\r\n  border-color: #20336c;\r\n}\r\n\r\n.otpModalBtnCancel {\r\n  flex: 1;\r\n  background-color: transparent;\r\n  border-color: #20336c;\r\n  color: #20336c;\r\n}\r\n\r\n.otpModalTextContent {\r\n  font-size: 14px;\r\n  color: #666;\r\n  margin-top: 12px;\r\n}\r\n\r\n.otpModalBtnResend {\r\n  font-size: 14px;\r\n  color: #1976d2;\r\n  margin-top: 12px;\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n  background: none;\r\n  border: none;\r\n}\r\n\r\n.fieldGroup {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.fieldGroup:last-of-type {\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.label {\r\n  font-family: Roboto, sans-serif;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #303030;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.fieldGroup .input {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.registerHint {\r\n  margin-top: 16px;\r\n  font-size: 13px;\r\n  color: #666;\r\n  text-align: center;\r\n  width: 100%;\r\n}\r\n\r\n.registerLink {\r\n  color: #1976d2;\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n}\r\n\r\n.passwordWrapper {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.passwordWrapper .input {\r\n  padding-right: 48px;\r\n}\r\n\r\n.eyeBtn {\r\n  position: absolute;\r\n  right: 14px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: fit-content !important;\r\n  display: inline-flex;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  color: #a4a4a4;\r\n  font-size: 18px;\r\n  line-height: 1;\r\n  align-items: center;\r\n}\r\n\r\n.eyeBtn:hover {\r\n  color: #303030;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var otpModal = `nnjQbyvo6p85dRdQ`;
export var otpModalText = `nWk881ue746gkOLT`;
export var uploadContent = `HGMUqI2pj2Iu0HUZ`;
export var input = `cq3mkuAwGgL04VoX`;
export var otpModalBtnVerify = `L9d7mBqzrsaaNfCx`;
export var otpModalBtnCancel = `nePuVgj7MA0xxekg`;
export var otpModalTextContent = `Pmlp5gzM2Q0MGbyt`;
export var otpModalBtnResend = `Tn7rqJi1qRAE5Exv`;
export var fieldGroup = `jQU8hZCKbTQKV2Re`;
export var label = `R01KiJXJW34Vj1xT`;
export var registerHint = `wvyYrTfKRsg5nVGe`;
export var registerLink = `XsvlCH_jhU0rN6jN`;
export var passwordWrapper = `vL03okZs5ACBWsq5`;
export var eyeBtn = `LcgwsQq__wGMqLpY`;
export default ___CSS_LOADER_EXPORT___;
